import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    eligibility: translate({ id: 'order.form.bulk.eligibility.field.label' }),
    invalidEligibilityNoDates: translate({
      id: 'order.form.bulk.errors.eligibility.invalid.noDates',
    }),
  }))

  return api
}
